module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9c43d786f5c08113feaeafb87275974a.png";